(() => {
  const intro = document.querySelector('.bm-intro');
  if (!intro || intro.dataset.bmReady) return;
  intro.dataset.bmReady = 'true';
  const root = intro.closest('.shopify-section');
  const summary = root?.querySelector('[data-bm-summary]');
  if (!root || !summary) return;
  let variants = [];
  try { variants = JSON.parse(summary.querySelector('[data-bm-variants]').textContent); } catch { return; }
  const money = new Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'});
  const parseMoney = text => {
    const clean = (text || '').replace(/[^\d,.-]/g, '');
    return Number(clean.includes(',') ? clean.replace(/\./g, '').replace(',', '.') : clean);
  };
  const put = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
  let scheduled = false;
  let counter = 0;
  const rowsFor = box => [...box.querySelectorAll('.st_select-boxes-wrapper')].map(row => [...row.querySelectorAll('select.st_selector')].map(select => select.value));
  const refresh = () => {
    scheduled = false;
    put(root.querySelector('.st_box-title'), 'Scegli il tuo pacchetto');
    const boxes = root.querySelectorAll('.st_bundle-box');
    boxes.forEach(box => {
      const count = Number(box.dataset.bundleBoxCount);
      const price = parseMoney(box.querySelector('.st_discounted-price')?.textContent);
      if (count > 0 && price > 0) put(box.querySelector('.st_input-highlighted-tag'), `${count} paia totali · ${money.format(price / count)} al paio`);
      put(box.querySelector('.st_highlighted-badge'), count === 8 ? 'MENO PER PAIO' : 'PER LA TUA ROUTINE');
      put(box.querySelector('.st_selectors-label'), 'Colore e taglia di ogni paio');
      const options = box.querySelector('.st_select-boxes');
      if (!options) return;
      let toggle = box.querySelector('.bm-customize');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'bm-customize';
        options.id = `bm-options-${++counter}`;
        options.classList.add('bm-collapsed');
        toggle.setAttribute('aria-controls', options.id);
        toggle.setAttribute('aria-expanded', 'false');
        toggle.innerHTML = '<span></span><strong>Personalizza colori e taglie +</strong>';
        toggle.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          options.classList.toggle('bm-collapsed', !expanded);
          put(toggle.querySelector('strong'), expanded ? 'Chiudi personalizzazione −' : 'Personalizza colori e taglie +');
        });
        options.before(toggle);
      }
      const combinations = [...new Set(rowsFor(box).map(options => options.join(' · ')))];
      put(toggle.querySelector('span'), combinations.length === 1 ? `Tutte le paia: ${combinations[0]}` : 'Colori e taglie personalizzati');
    });
    const active = root.querySelector('.st_bundle-box.active');
    if (!active) return;
    const count = Number(active.dataset.bundleBoxCount);
    const total = active.querySelector('.st_discounted-price')?.textContent.trim();
    put(root.querySelector('[data-bm-selection]'), count && total ? `Il tuo pacchetto: ${count} paia · ${total}` : '');
    put(document.querySelector('[data-bm-sticky-total]'), count && total ? `${count} paia · ${total}` : 'Scegli il tuo pacchetto');
    const selections = rowsFor(active);
    const chosen = selections.map(options => variants.find(v => v.options.every((value, i) => value === options[i]))).filter(Boolean);
    const demand = new Map();
    chosen.forEach(v => demand.set(v.id, (demand.get(v.id) || 0) + 1));
    const unavailable = chosen.find(v => !v.available || (v.tracked && v.policy === 'deny' && v.inventory < demand.get(v.id)));
    const low = chosen.find(v => v.available && v.tracked && v.policy === 'deny' && v.inventory > 0 && v.inventory <= 10);
    const stock = root.querySelector('[data-bm-stock]');
    if (stock) {
      const status = unavailable ? 'unavailable' : low ? 'low' : 'available';
      if (stock.dataset.status !== status) stock.dataset.status = status;
      put(stock, unavailable ? 'Una combinazione non è disponibile nella quantità scelta. Personalizza il pacchetto.' : low ? `Disponibilità limitata: ${low.title}.` : chosen.length ? 'Colori e taglie selezionati disponibili' : 'Disponibilità verificata quando scegli le varianti');
    }
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
  const observer = new MutationObserver(schedule);
  observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'selected', 'disabled']});
  root.addEventListener('change', schedule);
  root.addEventListener('click', schedule);
  refresh();
  document.querySelectorAll('[data-bm-open-faq]').forEach(link => link.addEventListener('click', () => {
    const details = document.querySelector(link.getAttribute('href'));
    if (details) details.open = true;
  }));
  const sticky = document.querySelector('[data-bm-sticky]');
  const button = root.querySelector('button[name="add"]');
  if (sticky && button && 'IntersectionObserver' in window) {
    const updateSticky = () => {
      const rect = button.getBoundingClientRect();
      sticky.hidden = rect.bottom > 0;
    };
    new IntersectionObserver(updateSticky).observe(button);
    window.addEventListener('scroll', updateSticky, {passive: true});
    updateSticky();
  }
})();
